import { Axios } from './../shared/Axios';
import qs from 'qs';

class AuthService extends Axios {

    private static instance: AuthService;

    static get(): AuthService {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }

    async login(data: object): Promise<any> {

        return this.instance.post(`/admin/auth/login`, data)
    }

    async changePassword(data: object): Promise<any> {

        return this.instance.post(`/admin/auth/change_password`, data)
    }




}


const authService = AuthService.get();

export { authService as AuthService }